/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_MarkdownInputs */

const en_image_inspector_markdown = /** @type {(inputs: Image_Inspector_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

const ar_image_inspector_markdown = /** @type {(inputs: Image_Inspector_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

const bn_image_inspector_markdown = /** @type {(inputs: Image_Inspector_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

const de_image_inspector_markdown = /** @type {(inputs: Image_Inspector_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

const es_image_inspector_markdown = /** @type {(inputs: Image_Inspector_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

const fr_image_inspector_markdown = /** @type {(inputs: Image_Inspector_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

const pt_image_inspector_markdown = /** @type {(inputs: Image_Inspector_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

const zh_image_inspector_markdown = /** @type {(inputs: Image_Inspector_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

const tr_image_inspector_markdown = /** @type {(inputs: Image_Inspector_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

const ru_image_inspector_markdown = /** @type {(inputs: Image_Inspector_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

const pl_image_inspector_markdown = /** @type {(inputs: Image_Inspector_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

/**
* | output |
* | --- |
* | "Markdown" |
*
* @param {Image_Inspector_MarkdownInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_markdown = /** @type {((inputs?: Image_Inspector_MarkdownInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_MarkdownInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_markdown(inputs)
	if (locale === "bn") return bn_image_inspector_markdown(inputs)
	if (locale === "de") return de_image_inspector_markdown(inputs)
	if (locale === "es") return es_image_inspector_markdown(inputs)
	if (locale === "fr") return fr_image_inspector_markdown(inputs)
	if (locale === "pt") return pt_image_inspector_markdown(inputs)
	if (locale === "zh") return zh_image_inspector_markdown(inputs)
	if (locale === "tr") return tr_image_inspector_markdown(inputs)
	if (locale === "ru") return ru_image_inspector_markdown(inputs)
	if (locale === "pl") return pl_image_inspector_markdown(inputs)
	return en_image_inspector_markdown(inputs)
});